import '~/assets/scss/product-bpif.scss'

import PageProduct from '~/js/modules/page-product';
import getSwiperSlider from '~/js/modules/slider';
import '~/js/modules/product/linked-funds'
import '~/js/modules/product/funds-year-replace'
import '~/js/modules/product/premium-discount'
import '~/js/modules/product/buy-online-links'
import '~/js/modules/tabs';
import SwitchStock from '~/js/modules/switch-stock';

new PageProduct();
window.addEventListener(`DOMContentLoaded`, () => {

  const productsSlider = document.querySelector(`.products__slider`);
  const productsSliderMobile = document.querySelector(`.products__slider-mobile`);
  const linkedSlider = document.querySelectorAll(`.linked-funds-slider`);
  const openDateInput = document.querySelector(`.js-pie-chart-datepicker`);
  let productsSwiper;
  let productsSwiperMobile;
  let linkedSwiper;

  openDateInput.addEventListener('click', (e) => {
    openDateInput.showPicker();
  })

  openDateInput.addEventListener('keydown', (e) => {
    e.preventDefault();
  })

  const productsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    pagination: false,
  };
  
  const linkedSwiperParams = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    slidesOffsetAfter: 16,
    loop: false,
    autoplay: false,
    pagination: false,
    navigation: {
      nextEl: '.linked-navigation .linked-next',
      prevEl: '.linked-navigation .linked-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 24,
        slidesOffsetAfter: 24,
      },
      960: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesOffsetAfter: 24,
      }
    }
  };

  if (linkedSlider && window.innerWidth < 960) {
    linkedSlider.forEach((ls) => {
      linkedSwiper = getSwiperSlider(ls, linkedSwiperParams);
    })
  }

  if (productsSlider) {
    productsSwiper = getSwiperSlider(productsSlider, productsSwiperParams);
  }

  if (productsSliderMobile) {
    productsSwiperMobile = getSwiperSlider(productsSliderMobile, productsSwiperParams);
  }

  const stock = document.querySelectorAll(`.js-stocks-container`);

  if (stock) {
    new SwitchStock({ container: 'stocksA', mode: 'slider' });
  }

  const isinCopyBtns = document.querySelectorAll(`.js-isin-copy`)
  if (isinCopyBtns) {
    isinCopyBtns.forEach((x) => {
      x.addEventListener('click', function () {
        let text = x.innerHTML;
        let copyhelper = document.createElement("input");
        document.body.appendChild(copyhelper);
        copyhelper.value = text;
        copyhelper.select();
        document.execCommand("copy");
        document.body.removeChild(copyhelper);
      })
    })
  }
})
